import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import Input from './Input';

const CustomInput = styled(Input)`
  width: calc(100% - 10px);
  padding: 5px;
  margin-right: 5px;
`;

const Container = styled.div`
  display: inline-flex;
  flex-direction: row;
  align-items: center;
  width: 100%;

  qds-icon {
    min-width: 24px !important;
    width: 24px !important;
    max-width: 24px !important;
    min-height: 24px !important;
    height: 24px !important;
    max-height: 24px !important;
  }

  ${({ hasError }) => {
    return hasError ? `
    ${CustomInput} {
      border: 1px solid red;
    }
    `: '';
  }}
`;

const EditHint = styled.span`
  display: inline-block;
  margin-left: 5px;
  ${props => props.color === 'primary' ? `
    color:  ${props => props.secondaryColor};
    color: var(--se-primary, ${props => props.secondaryColor});
  ` : (props.color === 'white' ? `color: white;` : `
    color:  ${props => props.primaryColor};
    color: var(--se-secondary, ${props => props.primaryColor});
  `)}
`;

const Icon = styled.span`
  display: flex;
  text-decoration: none !important;
  cursor: pointer;
`;
const DoneIcon = styled(Icon)`
  margin-left: 5px;
`;
const CancelIcon = styled(Icon)`
  color: ${props => props.color};
  margin-left: 5px;
`;

class DynamicInput extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      value: props.initialValue,
      hasError: false,
    };
  }

  static propTypes = {
    initialValue: PropTypes.string,
    setValue: PropTypes.func,
    withCancel: PropTypes.bool,
    cancel: PropTypes.func,
    customInputProps: PropTypes.object,
    primaryColor: PropTypes.string,
    secondaryColor: PropTypes.string
  }

  handleInputValueChange = (event) => {
    const { value } = event.target;
    if (this.state.value !== value) {
      this.setState({ value, hasError: false });
    } else {
      return false;
    }
  }

  validateValue(value) {
    const validateValueFunc = this.props.validateValue ? this.props.validateValue : v => true;
    return validateValueFunc(value);
  }

  render = () => {

    return (
      <Container hasError={this.state.hasError}>
        <CustomInput
          type="text"
          name="customInput"
          required
          value={this.state.value}
          onChange={this.handleInputValueChange}
          autoComplete="off"
          onKeyPress={(event) => {
            // 13 corresponds to the "Enter" key.
            if (event.key === 'Enter') {
              event.preventDefault();
              event.stopPropagation();
              const value = this.state.value;
              if (!this.validateValue(value)) {
                this.setState({ hasError: true });
              } else {
                this.props.setValue(value);
              }
            }
          }}
          {...this.props.customInputProps}
        ></CustomInput>
        {this.props.editHintText && <EditHint>{this.props.editHintText}</EditHint>}
        <DoneIcon onClick={(e) => {
          e.preventDefault();
          e.stopPropagation();
          const value = this.state.value;
          if (!this.validateValue(value)) {
            this.setState({ hasError: true });
          } else {
            this.props.setValue(value);
          }
        }}>
          <qds-icon name="check-small" size="small"></qds-icon>
        </DoneIcon>
        {this.props.withCancel &&
          <CancelIcon onClick={(e) => {
            e.preventDefault();
            e.stopPropagation();
            this.props.cancel();
          }}>
             <qds-icon name="cross-small" size="small"></qds-icon>
          </CancelIcon>
        }
      </Container>
    );
  }
}

export default DynamicInput;
